// src/directives/formatAmount.js
import { ElMessage } from 'element-plus';

export default {
  mounted(el, binding) {
    const decimalPlaces = binding.value ?? 2; // 默认为 2 位小数
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input');

    input.addEventListener('blur', (e) => {
      let value = e.target.value;
      if (!value) return;

      if (value <= 0) {
        e.target.value = null;
        input.dispatchEvent(new Event('input'));
        ElMessage.warning('金额必须大于0,请重新输入');
        return;
      }

      const numValue = Number(value);
      if (isNaN(numValue)) return;

      const fixedValue = numValue.toFixed(decimalPlaces);
      if (value.includes('.')) {
        const decimal = value.split('.')[1];
        if (decimal.length > decimalPlaces) {
          ElMessage.warning(`当前数值超过 ${decimalPlaces} 位小数，已自动截取`);
        }
      }
      e.target.value = fixedValue;
      input.dispatchEvent(new Event('input'));
    }, true);
  },
  unmounted(el) {
    el.removeEventListener('blur', () => { });
  }
};
